import { UUID } from 'angular2-uuid';
import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { Control } from '../../../../vas/business-objects/control/control.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const controlDuplicateReducer = (
    state = initialState,
    action: actions.ControlDuplicate
): State => {
    const controls = state.control.ids
        .map(id => state.control.entities[id]);

    const control = action.payload.control;

    let newTitleIndex = 1;
    let newTitle = `${control.title}-${newTitleIndex}`;
    let newName = `${control.name}-${newTitleIndex}`;

    while (
        controls.find(c => c.title === newTitle && c.name === newName)
        ) {
        newTitleIndex++;
        newTitle = `${control.title}-${newTitleIndex}`;
        newName = `${control.name}-${newTitleIndex}`;
    }

    const duplicate = new Control({
        ...control,
        id: UUID.UUID(),
        title: newTitle,
        name: newName
    });

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            controls: arrayPushUnique(state.dirtyIds.controls, duplicate.id)
        },
        control: {
            ...state.control,
            ids: [...state.control.ids, duplicate.id],
            entities: {
                ...state.control.entities,
                [duplicate.id]: duplicate
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-duplicate.reducer.ts